/**
 * Formats a role string for display by replacing underscores with spaces
 * and capitalizing each word.
 * 
 * @example
 * formatRoleLabel('school_liaison') // returns 'School Liaison'
 * formatRoleLabel('pta_admin') // returns 'Pta Admin'
 */
export function formatRoleLabel(role: string): string {
  return role
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
